const BogoHelper = {
  getAdjustedItems({ collectionHandles, variantId, requestedQty }) {
    const currentCollection = window.BOGO_COLLECTION_HANDLE;

    if (!collectionHandles.includes(currentCollection) || window.disabled_bogo) {
      return Promise.resolve([
        {
          id: variantId,
          quantity: requestedQty,
          properties: {}
        }
      ]);
    }

    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        let existingQty = 0;
        let freeInCart = 0;

        for (const item of cart.items) {
          if (item.variant_id === variantId) {
            existingQty += item.quantity;
            if (item.properties && item.properties.free_b2g1) {
              freeInCart += item.quantity;
            }
          }
        }

        const totalAfterAdd = existingQty + requestedQty;
        const nextGroupSize = Math.ceil(totalAfterAdd / 3) * 3;
        const eligibleFree = Math.floor(nextGroupSize / 3);
        const freeNeededNow = eligibleFree - freeInCart;
        const missingUnitsToNextGroup = nextGroupSize - totalAfterAdd;

        const items = [];

        // Always add normal items
        if (requestedQty > 0) {
          items.push({
            id: variantId,
            quantity: requestedQty,
            properties: {}
          });
        }

        if (requestedQty === 1 && totalAfterAdd < 2) {
          return items;
        }

        if (freeNeededNow > 0 && missingUnitsToNextGroup > 0) {
          items.push({
            id: variantId,
            quantity: missingUnitsToNextGroup,
            properties: {
              free_b2g1: true
            }
          });
        }

        else if (freeNeededNow > 0 && missingUnitsToNextGroup === 0) {
          items.push({
            id: variantId,
            quantity: 1,
            properties: {
              free_b2g1: true
            }
          });

          const normalItem = items.find(item => !item.properties.free_b2g1 && item.quantity > 1);
          if (normalItem) {
            normalItem.quantity -= 1;
          }
        }

        return items;
      });
  }
};
